import React from "react";
import { Header1, Highlight, JoinUsCont, Para } from "./SinglePriceStyledComp";

export default function JoinUs() {
  return (
    <JoinUsCont>
      <Header1>Join our community</Header1>
      <Highlight>30-day, hassle-free money back guarantee</Highlight>
      <Para>
        Gain access to our full library of tutorials along with expert code
        reviews. Perfect for any developers who are serious about honing their
        skills.
      </Para>
    </JoinUsCont>
  );
}
